import React, { FunctionComponent } from "react";
import styles from "./Announcement.module.scss";
import AnnouncementContent from "./AnnouncementContent.model";

import Anchor from "components/Anchor/Anchor";
import getImageCrop from "app/media/helpers/getImageCrop";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import getProcessedRichtext from "blocks/helpers/getProcessedRichtext";
import ImageViewer from "components/ImageViewer/ImageViewer";
import useWindowDimensions from "hooks/useWindowDimensions";

const Announcement: FunctionComponent<AnnouncementContent> = (props) => {
    const processedBodyText = getProcessedRichtext(props?.bodyText);

    const { width } = useWindowDimensions();
    const media = props?.media;
    const imageCrop = getImageCrop(media?.crops, undefined, width > 639 ? "Square (1:1)" : "Widescreen (16:9)");
    const imageAspectRatio = getImageAspectRatio(imageCrop, props?.media?.width, props?.media?.height);

    const link = props?.links && props?.links.length > 0 ? props?.links[0].link : undefined;
    return (
        <div className={styles.wrapper}>
            {/* Content */}
            <Anchor
                className={styles.content_link}
                to={link}
            >
                {/* Tagline */}
                {props?.tagline ? <span className={styles.tagline}>{props?.tagline}</span> : null}
                {/* Headline */}
                {props?.headline ? <h3 className={styles.heading}>{props?.headline}</h3> : null}

                {/* Body Text */}
                {processedBodyText ? (
                    <div
                        className={styles.text}
                        dangerouslySetInnerHTML={processedBodyText}
                    ></div>
                ) : null}
            </Anchor>

            {/* Media */}
            {props?.media ? (
                <Anchor
                    className={styles.media}
                    to={link}
                >
                    <ImageViewer
                        className={styles.image}
                        src={props?.media?.url || props?.media}
                        crop={imageCrop}
                        focalPoint={props?.media?.focalPoint}
                        {...imageAspectRatio}
                        alt={props?.headline}
                    />
                </Anchor>
            ) : null}
        </div>
    );
};

export default Announcement;
